import React from 'react'
import axios from 'axios';
import { NavLink } from 'reactstrap';
import { format } from 'date-fns'
import { FaBullhorn } from "react-icons/fa"
import { If, Then, Else } from 'react-if'
import ErrorSwal from '../components/SwalError'
import { useTranslation } from 'react-i18next'
import { Modal,Empty } from 'antd';
// import 'antd/dist/antd.css'


import { DashboardAnnouncement } from '../components/functions/DashboardPage'

const Annoucements = () => {

    const { t } = useTranslation()

    const [announcement, setAnnouncement] = React.useState([])
    const [error, setError] = React.useState(null)
    const cancelToken = React.useRef(null)
    const [isModalVisible, setIsModalVisible] = React.useState(false)
    const [values, setValues] = React.useState({
        Title: '',
        Detail: '',
        PostDate: '',
    })

    const getData = async () => {
        try {
            const response = await DashboardAnnouncement()

            setAnnouncement(response.data.announcement)

        } catch (error) {
            if (error?.response?.data) {
                const { data } = error.response
                setError(data.message)
            }
        }

    }
    React.useEffect(() => {
        cancelToken.current = axios.CancelToken.source()

        getData()

        return () => {
            cancelToken.current.cancel()
        }
    }, [])

    const handleOnClick = (ann) => {

        setValues({
            ...values,
            Title: ann.ANNOUNCE_TITLE,
            Detail: ann.ANNOUNCE_DETAIL,
            PostDate: format(new Date(ann.ANNOUNCE_DATE), 'dd/MM/yyyy'),
        })
        setIsModalVisible(true);

    }

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    if (error) {
        ErrorSwal({ title: 'Error', text: error, icon: 'error' })
        setError(null);
    }

    return (
        <>
        
            <div className="card" >
                <div className="card-content scroll-custom">
                    <div className="card-body">
                        <h4 className="card-title">  <span> <FaBullhorn /> </span> {t("t_announcement")} </h4>
                        <div className="card-announcement">
                            {announcement.length > 0 ? (
                                announcement.map((ann, index) => {
                                    return (
                                        <div key={index}>
                                            <If condition={ann.EXPIRATION_DATE === null || new Date().getTime() < new Date(ann.EXPIRATION_DATE).getTime()}>
                                            <Then>
                                                <NavLink className="card-content"   onClick={async () => { handleOnClick(ann) }}>
                                                    <div className="card-body" style={{padding: '1rem'}}>
                                                        <p className="text-title-Announcement">{ann.ANNOUNCE_TITLE}</p>
                                                        <p className="card-text">
                                                            {ann.ANNOUNCE_DETAIL}
                                                        </p>
                                                        <div className="d-flex justify-content-between">
                                                            <small className="text-muted"> {t("t_posted")} :   {
                                                                format(new Date(ann.ANNOUNCE_DATE), 'dd/MM/yyyy')
                                                            }</small>
                                                        </div>
                                                        <hr />
                                                    </div>
                                                </NavLink>
                                            </Then>
                                            <Else>
                                                <> </>
                                            </Else>
                                        </If>
                                    </div>
                                    )
                                })
                                ) :
                                        <Empty />
                            }
                        </div>
                    </div>
                </div>
            </div>

         
            <Modal
                style={{
                    top: 200,
                }}
                footer={null}
                title={values.Title}
                open={isModalVisible}
                onCancel={handleCancel}
            >
                <div className="mb-3 row g-3">
                    <p className="card-text"> {values.Detail}</p>
                </div>
                <div className="d-flex justify-content-between">
                    <small className="text-muted">  {t("t_posted")} : {values.PostDate}</small>
                </div>
            </Modal>
        </>
    )
}

export default Annoucements
